/**
 * Erkennt am Job-Fehler einer Auftragsuebernahme den Fall „Artikel lassen sich keinem
 * Vario-Artikel zuordnen" und zerlegt ihn in eine Zeile je Position.
 *
 * Der Anfang ist wortgleich mit `UNMAPPED_MESSAGE_PREFIX` in
 * `apps/worker/src/jobs/vario-order-create-from-kaufland.ts`. Die Einzelangaben trennt der
 * Worker mit `; ` (`resolveUnitsViaDefaultChannel`).
 */
export const UNMAPPED_MESSAGE_PREFIX =
  'Ein oder mehrere Artikel können keinem Artikel in Vario zugeordnet werden:';

/** `null`, wenn der Fehler ein anderer ist; sonst die Einzelangaben (ggf. leer). */
export function parseUnmappedFailure(error: string | null | undefined): string[] | null {
  if (!error) return null;
  const at = error.indexOf(UNMAPPED_MESSAGE_PREFIX);
  if (at < 0) return null;
  return error
    .slice(at + UNMAPPED_MESSAGE_PREFIX.length)
    .split(';')
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}
